export const HAS_DISMISSED_COMMERCE_SPECIALISTS_CUSTOM_RATE_ALERT = 'CommerceGrowth:HasDismissedCommerceSpecialistsCustomRateAlert';